module.exports = __webpack_public_path__ + "static/media/pasquale-gallo.8b3f752b.jpg";